import { render, staticRenderFns } from "./modal.vue?vue&type=template&id=5d0f06a4&scoped=true&"
import script from "./index.ts?vue&type=script&lang=ts&"
export * from "./index.ts?vue&type=script&lang=ts&"
import style0 from "./modal.vue?vue&type=style&index=0&id=5d0f06a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0f06a4",
  null
  
)

export default component.exports